import {Component, OnInit} from '@angular/core';
import {Page} from '../../../shared/models/page.interface';
import {PageRequest} from '../../../shared/models/page-request.interface';
import {MessageService} from '../../../shared/services/message.service';
import {ActivatedRoute, Router} from '@angular/router';
import {KfRegistrationService} from '../../services/kf-registration.service';
import {AuthService} from '../../../core/services/auth.service';
import {User} from '../../models/user.interface';
import {KfRegistration} from '../../../shared/models/kf-registration.interface';
import {KfRegistrationSearch} from '../../../shared/models/kf-registration-search.interface';

@Component({
  selector: 'app-kf-registration',
  templateUrl: './kf-registration.component.html',
  styleUrls: ['./kf-registration.component.scss']
})
export class KfRegistrationComponent implements OnInit {

  message = this.router.getCurrentNavigation()?.extras?.state?.message;

  kfRegistrationPage!: Page<KfRegistration>;
  user!: User;
  country!: boolean;
  private search!: KfRegistrationSearch;
  keyFigures = '';
  private readonly route!: string;
  private page: PageRequest = {page: 0, size: 100, sort: 'year', direction: 'desc'};

  constructor(private kfRegistrationService: KfRegistrationService,
              private messageService: MessageService,
              private router: Router,
              private authService: AuthService,
              private activatedRoute: ActivatedRoute) {
    this.route = router.url;
  }

  ngOnInit(): void {

    if (this.route.endsWith('putonmarket')) {
      this.keyFigures = 'Put On Market';
    } else if (this.route.endsWith('collected')) {
      this.keyFigures = 'Collected';
    } else if (this.route.endsWith('cost')) {
      this.keyFigures = 'Cost';
    } else if (this.route.endsWith('recycling')) {
      this.keyFigures = 'Recycling';
    } else {
      this.keyFigures = '';
    }

    this.country = this.route.includes('country');

    this.kfRegistrationService.getUser(this.authService.getEmail()).subscribe(
      data => {
        this.user = data;
        this.search = this.getActiveFilters();
        this.search.keyFigures = this.keyFigures;
        if (this.route.includes('country')) {
          this.search.countryId = this.user?.weeeSystem?.country?.id;
          this.search.schemaKind = 'COUNTRY_SCHEMA';
        }
        if (this.route.includes('weeesystem')) {
          this.search.weeeSystemId = this.user?.weeeSystem?.id;
          this.search.schemaKind = 'WEEE_SYSTEM_SCHEMA';
        }
        this.kfRegistrationService.getAllKfRegistrations(this.search, this.page).subscribe(
          data2 => {
            this.kfRegistrationPage = data2;
          }
        );
      }
    );

    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  loadKfRegistration(event: PageRequest): void {
    const search = this.getActiveFilters();
    this.kfRegistrationService.getAllKfRegistrations(search, event).subscribe(
      data => this.kfRegistrationPage = data
    );
    if (this.message) {
      this.messageService.showMessage(this.message, 'success');
      this.message = undefined;
    }
  }

  searchKfRegistration(search: KfRegistrationSearch): void {
    this.setUserData(search);
    this.router.navigate([this.router.url.split('?')[0]], {queryParams: this.buildQueryParams(search)});

    this.kfRegistrationService.getAllKfRegistrations(search, this.page).subscribe(
      data => this.kfRegistrationPage = data
    );
  }

  private setUserData(search: KfRegistrationSearch): void {
    if (this.route.includes('country')) {
      search.schemaKind = 'COUNTRY_SCHEMA';
      search.countryId = this.user.weeeSystem.country.id;
      search.keyFigures = this.keyFigures;
    }
    if (this.route.includes('weeesystem')) {
      search.schemaKind = 'WEEE_SYSTEM_SCHEMA';
      search.weeeSystemId = this.user.weeeSystem.id;
      search.keyFigures = this.keyFigures;
    }
  }

  private buildQueryParams(search: KfRegistrationSearch): any {
    const queryParams = {};

    if (search.startYear) {
      Object.assign(queryParams, {startYear: search.startYear});
    }
    if (search.endYear) {
      Object.assign(queryParams, {endYear: search.endYear});
    }

    if (search.b2bb2c && search.b2bb2c !== '') {
      Object.assign(queryParams, {b2bb2c: search.b2bb2c});
    }
    if (search.status) {
      Object.assign(queryParams, {status: search.status});
    }


    return queryParams;
  }

  private getActiveFilters(): KfRegistrationSearch {
    const search = {} as KfRegistrationSearch;
    this.activatedRoute.queryParams.subscribe((params) => {
      if (params.startYear) {
        search.startYear = params.startYear;
      }
      if (params.endYear) {
        search.endYear = params.endYear;
      }

      if (this.route.includes('country')) {
        search.schemaKind = 'COUNTRY_SCHEMA';
        search.countryId = this.user.weeeSystem.country.id;
        search.keyFigures = this.keyFigures;
      }
      if (this.route.includes('weeesystem')) {
        search.schemaKind = 'WEEE_SYSTEM_SCHEMA';
        search.weeeSystemId = this.user.weeeSystem.id;
        search.keyFigures = this.keyFigures;
      }
      if (params.b2bb2c) {
        search.b2bb2c = params.b2bb2c;
      }
      if (params.status) {
        search.status = params.status;
      }
      if (params.entry) {
        search.entry = params.entry;
      }
      if (params.keyFigures) {
        search.keyFigures = params.keyFigures;
      }
    });
    return search;
  }

}
